import React, { createContext, useContext, useState, useEffect } from 'react';
import apiClient from '../api';

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  // Initialize user from localStorage on app start
  useEffect(() => {
    const initializeUser = () => {
      const jwt_token = localStorage.getItem('jwt_token');
      const userData = localStorage.getItem('user_data');

      if (jwt_token && userData) {
        try {
          const parsedUser = JSON.parse(userData);
          setUser(parsedUser);
          setIsAuthenticated(true);
          // Set the authorization header for all future requests
          apiClient.defaults.headers.common[
            'Authorization'
          ] = `Bearer ${jwt_token}`;
        } catch (error) {
          console.error('Error parsing user data:', error);
          // Clear invalid data
          localStorage.removeItem('jwt_token');
          localStorage.removeItem('user_data');
        }
      }
      setIsLoading(false);
    };

    initializeUser();
  }, []);

  const login = (token, userData) => {
    // Store token and user data
    localStorage.setItem('jwt_token', token);
    localStorage.setItem('user_data', JSON.stringify(userData));

    // Set user state
    setUser(userData);
    setIsAuthenticated(true);

    // Set authorization header for all future requests
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  };

  const logout = () => {
    // Clear localStorage
    localStorage.removeItem('jwt_token');
    localStorage.removeItem('user_data');

    // Clear user state
    setUser(null);
    setIsAuthenticated(false);

    // Remove authorization header
    delete apiClient.defaults.headers.common['Authorization'];
  };

  const value = {
    user,
    isAuthenticated,
    isLoading,
    login,
    logout,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};
